/**
 * @fileoverview Shared image dropzone for email and WhatsApp notification types.
 * @module pages/notificationForm/NotificationFormImageDropzone
 */
import styles from "../../styles/NotificationForm.module.css";
import { ReactComponent as UploadIcon } from "../../assets/icons/Cloud_Upload.svg";
import { generateImageUrl } from "../../utils/common.js";
import AssetImage from "../../components/AssetImage";
import { useTranslation } from "react-i18next";

/** Image upload dropzone reused by EMAIL and WhatsApp notification blocks. */
const NotificationFormImageDropzone = ({
  imageRef,
  imagePreview,
  imagenUrl,
  error,
  onDragEnter,
  onDragLeave,
  onDrop,
  onImageChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.imageCol}>
      <label className={styles.label}>
        {t("pages.notificationForm.image")}
        <span className={styles.required}> *</span>
      </label>
      <div
        ref={imageRef}
        className={styles.dropFileInput}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        {imagePreview || imagenUrl ? (
          <AssetImage
            className={styles.uploadedImage}
            src={imagePreview || generateImageUrl(imagenUrl)}
            alt={t("common.bannerAlt")}
          />
        ) : (
          <div className={styles.uploadContainer}>
            <UploadIcon className={styles.uploadIcon} />
            {error && <span className={styles.errorMessage}>{error}</span>}
            <span className={styles.uploadTitle}>{t("common.drag&drop")}</span>
            <span className={styles.uploadSubtitle}>
              {t("common.yourImage")}{" "}
              <span style={{ color: "#1D5AE8" }} className={styles.uploadSubtitle}>
                {t("common.browseFile")}
              </span>
            </span>
          </div>
        )}
        <input
          className={styles.imageInput}
          type="file"
          accept="image/*"
          onChange={onImageChange}
        />
      </div>
    </div>
  );
};

export default NotificationFormImageDropzone;
